import { ApiBaseFront } from '../api-base-front';

export type RequestAlignImageToPpm = {
  id: string,
  dstKind: number,
  dstFilename: string,
}

type ParamType = {
  kijshopCd: string,
  /* クラウドフォルダの注文ID */
  cfOrderId: string,
  shopOrderId: string,
  info: RequestAlignImageToPpm[],
}

export class ApiAlignCfImageToPpm extends ApiBaseFront {
  constructor(_param: ParamType) {
    const { kijshopCd, cfOrderId, shopOrderId, info } = _param;
    super(
      'POST',
      `/api/v1/c-folder/shop/${kijshopCd}/order/${cfOrderId}/image/copy`,
      'JSON',
      {
        copyInfo: info,
        shopOrderId,
      },
    );
  }
}
